/**
 * Reads the snake_case signals, because that is what reaches the prompt. Both
 * of `useUser`'s sources are untransformed: the session user is `jwt_decode`
 * of the backend access token, and the profile GET goes through
 * `src/common/data-layer/datasources/ExternalHTTP`, which — unlike its `sb`
 * subclass — does not append `camelCaseObjectProperty` to `transformResponse`.
 * The serializer emits `needs_profile_completion`.
 */
type ProfileCompletionSignals = {
  needs_profile_completion?: boolean
}

export const needsProfileCompletion = (
  user?: ProfileCompletionSignals | null
): boolean => user?.needs_profile_completion === true
